/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { applyForm } from './modules';
import { header, menu } from './layouts';
import { slider, tabs, accordion, cookie, aosAnim, fancyboxGallery, videoJs } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();

  // Layouts
  header.init();
  // Layouts
  menu.init();


  // Partials Modules
  slider.init();
  tabs.init();
  aosAnim.init();
  accordion.init();
  cookie.init();
  fancyboxGallery.init();
  videoJs.init();
  applyForm.init();


  // Page Modules
}());
